import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export const YMAP_API_KEY = publicRuntimeConfig.YMAP_API_KEY;
export const MAX_ZOOM = 20;
export const DEFAULT_ZOOM = 9;
export const DEFAULT_CENTER = [55.75, 37.57];
